<template>
    <div class="tabs" :class="{ 'vertical': vertical, 'horizontal': !vertical }">
        <div class="shortlander" v-if="shortlander">
            <btn class="prev" i="angle-left" @press="scroll()" />
            <btn class="next" @press="scroll(true)" i="angle-right" />
        </div>
        <div class="tabs-navigation" :style="{width:vertical?verticalWidth+'px':''}">
            <div class='nav-tabs-wrapper'>
                <ul ref="tabNav" class="nav" role='tablist'>
                    <li v-for="(tab, index) in tabs" class="tab" :class="{['tab-size-'+size]:true}" name="tab" :key="index" role="presentation" @click="navigateToTab(index, tab.route)" :style="{maxWidth:maxTabWidth+'px'}">
                        <a href="javascript:void(0)"
                            :class="{ 'active': tab.active }"
                            :aria-selected="tab.active"
                            role="tab" @click="navigateToTab(index)">
                          <icon v-if="tab.icon" :name="tab.icon"/> <span>{{tab.title}}</span>
                          <!-- <span class="indicators">
                            <icon v-if="!tab.active" name="circle-thin"/>
                            <icon v-if="!tab.active" name="circle-o"/>
                            <icon v-if="tab.active" name="circle"/>
                          </span> -->
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="tab-content" :style="{marginLeft:vertical?verticalWidth+'px':''}">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: 'tabs',
    props: {
        maxTabWidth: {
            type: Number,
            default: 400
        },
        size: {
            type: String,
            default: "md"
        },
        verticalWidth: {
            type: Number,
            default: 180
        },
        type: {
            type: String,
            default: 'tabs'
        },
        vertical: {
            type: Boolean,
            default: false
        },
        shortlander: {
            type: Boolean,
            default: false
        },
        direction: {
            type: String,
            default: 'horizontal'
        },
        name: {
            type: String
        },
        centered: Boolean,
        value: [String, Number, Object]
    },
    mounted() {
        if (this.name) {
            if (localStorage[this.name + '-active-tab']) {
                this.activeTabIndex = parseInt(localStorage[this.name + '-active-tab']);
            }
        }
    },
    data: function data() {
        return {
            activeTabIndex: 0,
            tabs: []
        };
    },

    computed: {
        isTabShape: function isTabShape() {
            return this.type === 'tabs';
        },
        isStacked: function isStacked() {
            return this.direction === 'vertical';
        },
        classList: function classList() {
            var navType = this.isTabShape ? 'nav-tabs' : 'nav-pills';
            var centerClass = this.centered ? 'nav-justified' : '';
            var isStacked = this.isStacked ? 'nav-stacked' : '';
            return 'nav ' + navType + ' ' + centerClass + ' ' + isStacked;
        }
    },
    methods: {
        scroll(right) {
            let { tabNav } = this.$refs;
            let offset = 12;
            /*
                      var animation = animate(function frame() {
                        tabNav.scrollLeft+=right?offset:-offset;
                      }, 60);
                      setTimeout(()=>{
                        animation.pause();
                      }, 200);*/
        },
        navigateToTab: function navigateToTab(index, route) {
            this.changeTab(this.activeTabIndex, index, route);
        },
        activateTab: function activateTab(index) {
            this.activeTabIndex = index;
            var tab = this.tabs[index];
            tab.active = true;
            this.$emit('input', tab.title);
        },
        changeTab: function changeTab(oldIndex, newIndex, route) {
            this.activeTabIndex = newIndex;
            var oldTab = this.tabs[oldIndex];
            var newTab = this.tabs[newIndex];
            oldTab.active = false;
            newTab.active = true;
            this.$emit('input', this.tabs[newIndex].title);
            this.$emit('tab-change', newIndex, newTab, oldTab);
            this.tryChangeRoute(route);
            if (this.name) {
                localStorage[this.name + '-active-tab'] = newIndex;
            }
        },
        tryChangeRoute: function tryChangeRoute(route) {
            if (this.$router && route) {
                this.$router.push(route);
            }
        },
        addTab: function addTab(item) {
            var index = this.$slots.default.indexOf(item.$vnode);
            this.tabs.splice(index, 0, item);
        },
        removeTab: function removeTab(item) {
            var tabs = this.tabs;
            var index = tabs.indexOf(item);
            if (index > -1) {
                tabs.splice(index, 1);
            }
        },
        getTabs: function getTabs() {
            if (this.$slots.default) {
                return this.$slots.default.filter(function(comp) {
                    return comp.componentOptions;
                });
            }
            return [];
        },
        findTabAndActivate: function findTabAndActivate(tabNameOrIndex) {
            var indexToActivate = this.tabs.findIndex(function(tab, index) {
                return tab.title === tabNameOrIndex || index === tabNameOrIndex;
            });
            if (indexToActivate != -1) {
                this.changeTab(this.activeTabIndex, indexToActivate);
            } else {
                this.changeTab(this.activeTabIndex, 0);
            }
        }
    },

    watch: {
        tabs: function tabs(newList) {
            if (newList.length > 0 && !this.value) {
                this.activateTab(this.activeTabIndex);
            }
            if (newList.length > 0 && this.value) {
                this.findTabAndActivate(this.value);
            }
        },
        value: function value(newVal) {
            this.findTabAndActivate(newVal);
        }
    }
}
</script>
<style scoped>
ul {
    padding: 0;
    margin: 0;
}

li {
    list-style: none;
    display: inline-block;
}

.nav {
    white-space: nowrap;
    /*overflow:hidden;*/
}

.tabs-navigation {
    border-bottom: 1px solid lightgrey;
    /*overflow: hidden;*/
}

.tab .indicators {
    font-size: 8px;
    vertical-align: middle;
    width: 16px;
    overflow: hidden;
    display: inline-block;
}

.tab a {
    cursor: pointer;
    padding: 4px 10px;
    border: 1px solid lightgrey;
    display: inline-block;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    margin-top: 5px;
    margin-left: 5px;
    margin-bottom: -1px;
    text-align: center;
    color: black;
    background: #ececec;
    position: relative;
    color: grey;
}

.tab a.active {
    background: white;
    color: black;
}

.horizontal .tab a.active {
    border-bottom-color: white;
}

.horizontal .tab a.active:before {
    content: '';
    background: white;
    height: 1px;
    position: absolute;
    width: 100%;
    left: 0;
    bottom: -1px;
}

.fa {
    width: 20px;
}

.fa-circle-o {
    display: none;
}

.tab a:hover .fa-circle-thin {
    display: none;
}

.tab a:hover .fa-circle-o {
    display: inline-block;
}








.shortlander {
    display: inline-block;
    width: 54px;
    float: right;
    padding: 3px;
    border-left: 1px solid lightgrey;
    border-bottom: 1px solid lightgrey;
    overflow: hidden;
    z-index: 9999;
    position: relative;
    background: white;
}

.shortlander .btn {
    display: inline-block;
    border: 1px solid lightgrey;
    padding: 5px 0px;
    width: 44%;
    text-align: center;
    border-radius: 2px;

}

.padded .tab-content {
    /*padding:4px 8px;*/
}




.vertical .tab {
    display: block;

}

.vertical .tab a {
    display: block;
    width: 100%;
    margin: 0;
    text-align: left;
    border-top: none;
    border-right: none;
    padding: 8px;
    border-radius: 0;

}

.vertical .tabs-navigation {
    height: 480px;
    width: 180px;
    float: left;
    border-bottom: none;
    border-right: 1px solid lightgrey;
}

.vertical .tab-content {
    margin-left: 180px;
}

a {
    text-decoration: none;
}

.tab-size-xs {
    font-size: 12px;

}

.tab-size-xs a {
    padding: 2px 4px;
    margin: 0;
}

.tab-size-xs {
    margin-left: -1px;
}

.tab-size-xs:first-child {
    margin-left: 3px;
}

.tab-size-sm {}

.tab-size-md {}

.tab-size-lg {}

.tab-size-xl {}

@media(max-width:890px) {

    .tab a,
    .tab {
        width: 100%;
    }

    .horizontal .tab a.active:before {
        display: none;
    }

    .horizontal .tab a.active {
        border-bottom-color: lightgrey;
    }

    .tab a {
        border-radius: 4px;

    }

    .nav {
        white-space: normal;
    }

    .tabs-navigation {
        border-bottom: none;
    }
}
</style>